module.exports = __webpack_public_path__ + "img/H1M9_new.795bc723.jpg";